import React from 'react'
import { Modal } from '@components/ui'

type MessageCenterBlockContactModalProps = {
  show: boolean
  contactName: string
  onCancel: () => void
  onBlock: () => void
}

const MessageCenterBlockContactModal: React.FC<
  MessageCenterBlockContactModalProps
> = ({ show, contactName, onCancel, onBlock }) => {
  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      title="Block user"
      aria-label={`Block ${contactName.trim() || 'user'}`}
      description="After blocking, they won’t be able to message you again."
      primaryLabel="Block"
      secondaryLabel="Cancel"
      primaryDestructive
      onPrimaryClick={() => {
        onBlock()
        onCancel()
      }}
      onSecondaryClick={onCancel}
    />
  )
}

export default MessageCenterBlockContactModal
